<script lang="ts" setup>
import type { Menu } from '~/types/models/menu'

interface Props {
  item: Menu.MenuItem
  childrenWrapperClass?: string
}

defineProps<Props>()
</script>

<template>
  <li
    itemtype="https://www.schema.org/SiteNavigationElement"
    :aria-haspopup="item.children.length > 0"
  >
    <a
      :id="`element-${item.id}`"
      :href="item.value"
      :target="item.target"
      :data-track-analytics-id="item.analyticsId"
    >{{ item.name }}</a>
    <ul
      v-if="item.children.length > 0"
      :class="childrenWrapperClass"
    >
      <li class="wrapper">
        <ul>
          <template v-for="childrenMenuItem in item.children">
            <Component
              :is="childrenMenuItem.component"
              v-if="childrenMenuItem?.component"
              :key="childrenMenuItem.id"
              :item="childrenMenuItem"
              :children-wrapper-class="childrenWrapperClass"
            />
          </template>
        </ul>
      </li>
    </ul>
  </li>
</template>
